export const ELLIPSIS = '\u2026';
